module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    staticClass: "learning-guide-modal",
    attrs: {
      "id": _vm.id,
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "domain-guide-container"
  }, [_c('div', {
    staticClass: "domain-guide-header"
  }, [_vm._v(_vm._s(_vm.$t('domain.tutorial.title')))]), _vm._v(" "), _c('div', {
    staticClass: "domain-guide-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('domain.tutorial.section'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "domain-guide-example"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/img-sam-info-card.png",
      "alt": "icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "domain-guide-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/group-3.png",
      "alt": "icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('domain.tutorial.button')))])])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cc2bbf1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/components/CatDomainGuide.vue
// module id = 1564
// module chunks = 1